import { Component, OnInit } from '@angular/core';
import { FullScreenService } from 'src/app/service/fullscreen.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Router } from "@angular/router"
import { LocalStorage } from 'ngx-store';
import { CaptchaService } from 'src/app/service/captcha.service';

@Component({
  selector: 'captcha-area',
  templateUrl: './captcha-area.component.html',
  styleUrls: ['./captcha-area.components.css']
})


export class CaptchaComponent implements OnInit {

  aFormGroup: FormGroup;
  fullScreen = true;
  setFullScreen = true;

  @LocalStorage('isCaptchaSolved') isCaptchaSolved: any;
  @LocalStorage('redirectTo') redirectTo: any;


  constructor(
    public fullScreenService: FullScreenService,
    private formBuilder: FormBuilder,
    private router: Router,
    public captchaService : CaptchaService) {
  }

  hide = false

 // siteKey:string = environment.recaptcha.siteKey;
  siteKey:string='6LcRvXomAAAAAOYvYWh2A4NNZ9hBX3ra9wYA2LWj';
  ngOnInit(): void {
    this.setFullScreen = true;
    this.fullScreenService.setFullScreen(true)

    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });


  }

  async handleSuccess ($event): Promise<void> {
    this.isCaptchaSolved = true;
    //window.alert("Capcha solved: "+this.isCaptchaSolved+" Redirect to: '"+ this.redirectTo+"'"+ "Form value"+this.aFormGroup);
    this.setFullScreen = false;
    this.fullScreenService.setFullScreen(false);
    //window.alert(this.redirectTo);
    this.router.navigate([this.redirectTo]);
    this.isCaptchaSolved = true;

  }




}
